var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimatedVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    viewBox: "0 0 39 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.5H30C30.8284 7.5 31.5 8.17157 31.5 9V22.5V28C31.5 28.8284 30.8284 29.5 30 29.5H2C1.17157 29.5 0.5 28.8284 0.5 28V9C0.5 8.17157 1.17157 7.5 2 7.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7V6C3 4.89543 3.89543 4 5 4H33C34.1046 4 35 4.89543 35 6V22.5V25C35 26.1046 34.1046 27 33 27H32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0909 24H36C37.1046 24 38 23.1046 38 22V12.5V3C38 1.89543 37.1046 1 36 1H8C6.89543 1 6 1.89543 6 3V4",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26L29 26",
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11L29 11",
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 18.067C20.5833 18.2594 20.5833 18.7406 20.25 18.933L15 21.9641C14.6667 22.1566 14.25 21.916 14.25 21.5311L14.25 15.4689C14.25 15.084 14.6667 14.8434 15 15.0359L20.25 18.067Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedVideoIcon);
export default __webpack_public_path__ + "static/media/animatedVideoIcon.af3aa89d6c946df4bcddf1faa71adf68.svg";
export { ForwardRef as ReactComponent };